import React from 'react';

import PropTypes from 'prop-types';

const Button = ({ label }) => {
  return <option value="">{label}</option>;
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
};

export default Button;
